import { render, staticRenderFns } from "./SignupSourcesCard.vue?vue&type=template&id=3a319f09"
import script from "./SignupSourcesCard.vue?vue&type=script&lang=js"
export * from "./SignupSourcesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports